import * as tslib_1 from "tslib";
import * as React from 'react';
import { documentTypes } from '../../store/DocumentStore';
import { parseNumber } from 'src/utils/parsing';
var selectStyle = {
    background: 'transparent',
    border: '1px solid #ddd',
    paddingLeft: '50px',
    height: '25px'
};
var labelStyle = {
    color: 'black',
    marginRight: '-50px'
};
var TaskDocumentTypes = /** @class */ (function (_super) {
    tslib_1.__extends(TaskDocumentTypes, _super);
    function TaskDocumentTypes(props) {
        var _this = _super.call(this, props) || this;
        _this.handleTypeSelected = function (e) {
            e.preventDefault();
            var type = parseNumber(e.target.value);
            _this.props.onTypeChanged(type);
        };
        return _this;
    }
    TaskDocumentTypes.prototype.render = function () {
        var _this = this;
        var options = documentTypes.map(function (i) { return (React.createElement("option", { key: i.id, value: i.id },
            i.name,
            " ", "(" + _this.props.documentStore.getDocumentCountByType(i.id) + ")")); });
        return (React.createElement(React.Fragment, null,
            React.createElement("small", { style: labelStyle }, "T\u00EDpus: "),
            React.createElement("select", { style: selectStyle, value: this.props.selectedType, onChange: this.handleTypeSelected }, options)));
    };
    return TaskDocumentTypes;
}(React.Component));
export default TaskDocumentTypes;



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskDocumentTypes.tsx
// module id = 738
// module chunks = 0